
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import {persistStore, createTransform} from 'redux-persist';
import CryptoJS from 'crypto-js';
import AppRoutes from './router';
import { createBrowserHistory } from 'history';
import ConfigureStore from './configure-store';
import IzendaIntegrate from '../helper/IzendaIntegrate';
import '../app.scss';

window.jQuery = window.$ = $;
import 'bootstrap';

let store = ConfigureStore();
let izendaInterval = null;

class App extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      loading: true
    };
  }

  componentWillMount() {
    izendaInterval = setInterval(() => {
      if (window.IzendaSynergy) {
        IzendaIntegrate.DoIzendaConfig();
        clearInterval(izendaInterval);
      }
    }, 1000);
    const encryptTransform = createTransform(
      (inboundState) => {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(inboundState), 'OBAASH7HOQCFOYYD');
        return encrypted.toString();
      },
      (outboundState) => {
        const decrypted = CryptoJS.AES.decrypt(outboundState, 'OBAASH7HOQCFOYYD');
        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      },
      { whitelist: ['LotStore'] }
    );

    persistStore(store, {
      transforms: [encryptTransform],
      whitelist: ['LotStore']
    }, () => {
      this.setState({ loading: false });
    });
  }

  render() {
    let history = createBrowserHistory({ basename: '/' });

    if (this.state.loading) {
      return '';
    }

    return (
      <Provider store={store}>
        <Router history={history}>
          <AppRoutes />
        </Router>
      </Provider>
    );
  }

}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/portal_system/index.js